import React from 'react'
import { HorizontalStack, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { useBillOfMaterialsContext } from './Context'
import { AddNewButton } from './RowContextMenu'
import type { useToggle } from 'react-use'

export const BomHead = ({ topLevelAddToggle }: { topLevelAddToggle: ReturnType<typeof useToggle> }) => {
  const { showInventoryFields } = useBillOfMaterialsContext()

  return (
    <thead>
      <tr className="table-secondary">
        <th>
          <HorizontalStack gap={4}>
            <div>Product</div>
            <AddNewButton showAddNewToggle={topLevelAddToggle} title={'Add new sub-assembly'} />
          </HorizontalStack>
        </th>

        <TooltipPopOver tooltipBody="This is the number of units required to build the single unit of final product">
          <th style={{ width: '15%' }} className={'text-end'}>
            Qty. required
          </th>
        </TooltipPopOver>
        <TooltipPopOver tooltipBody="This determines if this product is required to build the final product.">
          <th style={{ width: '12%' }} className={'text-end'}>
            Required?
          </th>
        </TooltipPopOver>

        <ShowIf condition={showInventoryFields}>
          <TooltipPopOver tooltipBody="The number of units needed to build the parent product">
            <th style={{ width: '8%' }} className={'text-end'}>
              Needed
            </th>
          </TooltipPopOver>
          <TooltipPopOver tooltipBody="The number of units that will be consumed (from the current inventory) to build the parent product">
            <th style={{ width: '8%' }} className={'text-end'}>
              Consumed
            </th>
          </TooltipPopOver>
          <TooltipPopOver tooltipBody="The number of units that is left after the consumption.">
            <th style={{ width: '8%' }} className={'text-end'}>
              Remaining
            </th>
          </TooltipPopOver>
        </ShowIf>

        <TooltipPopOver tooltipBody="The total cost to build this product">
          <th style={{ width: '12%' }} className={'text-end'}>
            Cost
          </th>
        </TooltipPopOver>
      </tr>
    </thead>
  )
}
